import { render, staticRenderFns } from "./CompositeMetrics.vue?vue&type=template&id=1ccb1c7a&scoped=true"
import script from "./CompositeMetrics.vue?vue&type=script&lang=js"
export * from "./CompositeMetrics.vue?vue&type=script&lang=js"
import style0 from "./CompositeMetrics.vue?vue&type=style&index=0&id=1ccb1c7a&prod&lang=scss&scoped=true"
import style1 from "./CompositeMetrics.vue?vue&type=style&index=1&id=1ccb1c7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccb1c7a",
  null
  
)

export default component.exports